import { Component, OnInit } from '@angular/core';
import { ABExperimentsService } from 'modules/experiments/services/ABExperiments.service';

@Component({
	selector: 'experiment-controls-widget',
	templateUrl: './experiment-controls-widget.component.html',
	styleUrls: ['./experiment-controls-widget.component.scss'],
})
export class ExperimentControlsWidgetComponent implements OnInit {
	public experiments: any[] = [];
	public isExpanded = false;
	constructor(private abExperimentsService: ABExperimentsService) {}

	ngOnInit(): void {
		this.experiments = this.abExperimentsService
			.getAllExperiments()
			.map((experiment) => {
				return {
					label: experiment.name,
					items: experiment.variant_names.map((variant) => {
						return {
							icon: this.getActiveIcon(experiment.currentVariant, variant),
							label: `Variante - ${variant}`,
							command: () => {
								this.abExperimentsService.forceUseVariantOnExperient(
									experiment.name,
									variant
								);
								this.remountExperiments(
									this.abExperimentsService.getVariantByExperimentName(
										experiment.name
									)
								);
							},
							value: variant,
						};
					}),
				};
			});
	}

	remountExperiments(currentVariant) {
		this.experiments = this.experiments.map((experiment) => {
			return {
				...experiment,
				items: experiment.items.map((itemVariant) => {
					return {
						...itemVariant,
						icon: this.getActiveIcon(currentVariant, itemVariant.value),
					};
				}),
			};
		});
	}

	getActiveIcon(currentVariant, variant) {
		return currentVariant !== variant
			? 'freud-icon freud-icon-circle'
			: 'freud-icon freud-icon-circle-fill';
	}

	toggleExpanded() {
		this.isExpanded = !this.isExpanded;
	}
}
